module.exports = __webpack_public_path__ + "img/to_kf_black.82a2acbf.svg";